import { useToggle } from '@lemonade-hq/cdk';
/* eslint-disable react/jsx-no-constructed-context-values */
import type React from 'react';
import { createContext } from 'react';

interface ModalsContextInterface {
  help: {
    isHelpModalOpen: boolean;
    openHelpModal: () => void;
    closeHelpModal: () => void;
  };
}

export const ModalsContext = createContext({} as ModalsContextInterface);

interface ModalsContextProviderProps {
  children: React.ReactNode;
}

export const ModalsContextProvider: React.FC<ModalsContextProviderProps> = ({ children }) => {
  const { isOpen: isHelpModalOpen, open: openHelpModal, close: closeHelpModal } = useToggle();

  const modalsStore = {
    help: { isHelpModalOpen, openHelpModal, closeHelpModal },
  };
  return <ModalsContext.Provider value={modalsStore}>{children}</ModalsContext.Provider>;
};
